import React from "react";

const WarnIcon = props => (
  <svg
    style={props.style}
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    fill="none"
    viewBox="0 0 15 15"
  >
    <circle cx="7.5" cy="7.5" r="7.5" fill={props.color}></circle>
    <path
      fill="#fff"
      d="M11.813 8.887l-3.18-6.202a1.28 1.28 0 00-2.267 0L3.187 8.887C2.665 9.819 3.297 11 4.321 11h6.358c1.023 0 1.656-1.18 1.134-2.113zM7.5 9.88c-.29 0-.527-.251-.527-.56 0-.308.236-.56.527-.56.29 0 .527.252.527.56 0 .309-.236.56-.527.56zm.527-2.239c0 .309-.236.56-.527.56-.29 0-.527-.251-.527-.56V4.844c0-.308.236-.56.527-.56.29 0 .527.252.527.56v2.798z"
    ></path>
  </svg>
);

export default WarnIcon;



// WEBPACK FOOTER //
// ./src/icons/WarnIcon.jsx